import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import {
   IconButton,
   Paper,
   Table,
   TableBody,
   TableCell,
   TableContainer,
   TableHead,
   TablePagination,
   TableRow,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import useResources from "../../../../../hooks/useResources";
import useResourceTypes from "../../../../../hooks/useResourceTypes";
import { resourceAction } from "../../../../../redux/resources-slice";
import ConfirmationDialog from "../../../../components/confirmationModal/DeleteConfirmationModal";
import Emptystate from "../../../../components/emptystate/emptystate";
import Spinner from "../../../../components/spinner/spinner";
import classes from "./ResourcesTable.module.css";

const ResourcesTable = () => {
   const {
      resources: { resourceResponse, getLoading },
   } = useSelector((state) => state);

   const { onSetResourceType } = useResourceTypes();

   const {
      getResources,
      openResourceForm,
      closeDeleteDialog,
      openDeleteDialog,
      openDialog,
      deleteResource,
   } = useResources();
   const dispatch = useDispatch();

   const updateResource = (resourceType) => {
      dispatch(resourceAction.setSingleResource(resourceType));
      openResourceForm();
   };

   const onDeleteResource = (resourceType) => {
      dispatch(resourceAction.setSingleResource(resourceType));

      openDeleteDialog();
   };

   const handleChangePage = (_, newPage) => {
      getResources({
         pageSize: resourceResponse?.pageable?.pageSize,
         pageNo: newPage,
      });
   };

   const handleChangeRowsPerPage = (event) => {
      getResources({ pageSize: event.target.value, pageNo: 0 });
   };
   return (
      <>
         <ConfirmationDialog
            deleteDialogIsOpen={openDialog}
            closeDeleteDialog={closeDeleteDialog}
            successDialog={deleteResource}
            recordName={"Delete resource?"}
         />
         <TableContainer
            component={Paper}
            sx={{ maxHeight: "60vh", maxWidth: "90vw" }}
         >
            {getLoading ? (
               <Spinner />
            ) : (
               resourceResponse?.content &&
               resourceResponse?.content?.length > 0 && (
                  <Table stickyHeader aria-label="sticky table">
                     <>
                        <TableHead>
                           <TableRow className={classes.table_row}>
                              <TableCell className={classes.table_cell}>
                                 ID
                              </TableCell>
                              <TableCell className={classes.table_cell}>
                                 Name
                              </TableCell>
                              <TableCell className={classes.table_cell}>
                                 Resource Type
                              </TableCell>
                              <TableCell className={classes.table_cell}>
                                 Resource Link
                              </TableCell>
                              <TableCell className={classes.table_cell}>
                                 Resource Payment Link
                              </TableCell>

                              <TableCell className={classes.table_cell}>
                                 Action
                              </TableCell>
                           </TableRow>
                        </TableHead>
                        <TableBody>
                           <>
                              {resourceResponse?.content?.map((resource) => (
                                 <TableRow
                                    key={resource.id}
                                    sx={{
                                       "&:last-child td, &:last-child th": {
                                          border: 0,
                                       },
                                    }}
                                 >
                                    <TableCell
                                       component="th"
                                       scope="row"
                                       style={{ minWidth: 150 }}
                                    >
                                       {resource.id}
                                    </TableCell>
                                    <TableCell style={{ minWidth: 250 }}>
                                       {resource.name}
                                    </TableCell>

                                    <TableCell style={{ minWidth: 250 }}>
                                       {onSetResourceType(resource)?.name}
                                    </TableCell>
                                    <TableCell style={{ minWidth: 400 }}>
                                       <a href={resource.pdfUrl}>
                                          {" "}
                                          link to {resource.name}{" "}
                                       </a>
                                    </TableCell>

                                    <TableCell style={{ minWidth: 400 }}>
                                       {resource.paymentLink ? (
                                          <a href={resource.paymentLink}>
                                             {" "}
                                             payment link{" "}
                                          </a>
                                       ) : (
                                          ""
                                       )}
                                    </TableCell>

                                    <TableCell style={{ minWidth: 150 }}>
                                       <IconButton
                                          onClick={() =>
                                             updateResource(resource)
                                          }
                                       >
                                          <CreateIcon
                                             className={classes.edit}
                                          />
                                       </IconButton>
                                       <IconButton
                                          onClick={() =>
                                             onDeleteResource(resource)
                                          }
                                       >
                                          <DeleteIcon
                                             className={classes.delete}
                                          />
                                       </IconButton>
                                    </TableCell>
                                 </TableRow>
                              ))}
                           </>
                        </TableBody>
                     </>
                  </Table>
               )
            )}
         </TableContainer>

         {!getLoading &&
            resourceResponse?.content &&
            resourceResponse?.content?.length > 0 && (
               <TablePagination
                  count={resourceResponse.totalElements ?? 0}
                  shape="rounded"
                  page={resourceResponse?.pageable?.pageNumber ?? 0}
                  rowsPerPage={resourceResponse?.pageable?.pageSize ?? 10}
                  className={classes.pagination}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
               />
            )}

         {!getLoading &&
            (!resourceResponse?.content ||
               resourceResponse?.content?.length === 0) && (
               <Emptystate name="resource" />
            )}
      </>
   );
};

export default ResourcesTable;
